module.exports = __webpack_public_path__ + "8356149ac70513da313116f7987314ff.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/base/base-26.png
// module id = 1762
// module chunks = 0